export const PARTICIPANT_ACTIVITY_REQUEST = 'PARTICIPANT_ACTIVITY_REQUEST'
export const PARTICIPANT_ACTIVITY_SUCCESS = 'PARTICIPANT_ACTIVITY_SUCCESS'
export const PARTICIPANT_ACTIVITY_ERROR = 'PARTICIPANT_ACTIVITY_ERROR'
export const PARTICIPANT_ACTIVITY_CREATE = 'PARTICIPANT_ACTIVITY_CREATE'
export const PARTICIPANT_ACTIVITY_FIND_ONE = 'PARTICIPANT_ACTIVITY_FIND_ONE'
export const PARTICIPANT_ACTIVITY_DELETE = 'PARTICIPANT_ACTIVITY_DELETE'
